module.exports = __webpack_public_path__ + "static/media/Macbook_20200903.0c69563b.mp4";